import { useChapterObserver } from "@/hooks/useChapterObserver";

export function ChapterCounter() {
  const active = useChapterObserver();
  const num = active.slice(1);
  return (
    <span
      className="type-meta-sm"
      style={{
        color: "var(--fog)",
        opacity: 0.7,
        fontVariantNumeric: "tabular-nums",
      }}
    >
      CH—{num}
    </span>
  );
}
